import sheet_thumb01_stock from '../../img/template_thumnail/sheet/sheet_thumb01_stock.png';
import sheet_thumb01_stock2x from '../../img/template_thumnail/sheet/sheet_thumb01_stock@2x.png';
import sheet_thumb02_attendancebook from '../../img/template_thumnail/sheet/sheet_thumb02_attendancebook.png';
import sheet_thumb02_attendancebook2x from '../../img/template_thumnail/sheet/sheet_thumb02_attendancebook@2x.png';
import sheet_thumb03_babycarerecord from '../../img/template_thumnail/sheet/sheet_thumb03_babycarerecord.png';
import sheet_thumb03_babycarerecord2x from '../../img/template_thumnail/sheet/sheet_thumb03_babycarerecord@2x.png';
import sheet_thumb04_breakevenpoint from '../../img/template_thumnail/sheet/sheet_thumb04_breakevenpoint.png';
import sheet_thumb04_breakevenpoint2x from '../../img/template_thumnail/sheet/sheet_thumb04_breakevenpoint@2x.png';
import sheet_thumb05_budgetplanner1 from '../../img/template_thumnail/sheet/sheet_thumb05_budgetplanner1.png';
import sheet_thumb05_budgetplanner12x from '../../img/template_thumnail/sheet/sheet_thumb05_budgetplanner1@2x.png';
import sheet_thumb06_budgetplanner2 from '../../img/template_thumnail/sheet/sheet_thumb06_budgetplanner2.png';
import sheet_thumb06_budgetplanner22x from '../../img/template_thumnail/sheet/sheet_thumb06_budgetplanner2@2x.png';
import sheet_thumb07_chart from '../../img/template_thumnail/sheet/sheet_thumb07_chart.png';
import sheet_thumb07_chart2x from '../../img/template_thumnail/sheet/sheet_thumb07_chart@2x.png';
import sheet_thumb09_estimate from '../../img/template_thumnail/sheet/sheet_thumb09_estimate.png';
import sheet_thumb09_estimate2x from '../../img/template_thumnail/sheet/sheet_thumb09_estimate@2x.png';
import sheet_thumb10_health from '../../img/template_thumnail/sheet/sheet_thumb10_health.png';
import sheet_thumb10_health2x from '../../img/template_thumnail/sheet/sheet_thumb10_health@2x.png';
import sheet_thumb11_invoice from '../../img/template_thumnail/sheet/sheet_thumb11_invoice.png';
import sheet_thumb11_invoice2x from '../../img/template_thumnail/sheet/sheet_thumb11_invoice@2x.png';
import sheet_thumb12_loancalculator from '../../img/template_thumnail/sheet/sheet_thumb12_loancalculator.png';
import sheet_thumb12_loancalculator2x from '../../img/template_thumnail/sheet/sheet_thumb12_loancalculator@2x.png';
import sheet_thumb13_meetingannouncement from '../../img/template_thumnail/sheet/sheet_thumb13_meetingannouncement.png';
import sheet_thumb13_meetingannouncement2x from '../../img/template_thumnail/sheet/sheet_thumb13_meetingannouncement@2x.png';
import sheet_thumb14_report from '../../img/template_thumnail/sheet/sheet_thumb14_report.png';
import sheet_thumb14_report2x from '../../img/template_thumnail/sheet/sheet_thumb14_report@2x.png';
import sheet_thumb15_teamlist from '../../img/template_thumnail/sheet/sheet_thumb15_teamlist.png';
import sheet_thumb15_teamlist2x from '../../img/template_thumnail/sheet/sheet_thumb15_teamlist@2x.png';
import sheet_thumb16_trip from '../../img/template_thumnail/sheet/sheet_thumb16_trip.png';
import sheet_thumb16_trip2x from '../../img/template_thumnail/sheet/sheet_thumb16_trip@2x.png';

export const SheetTemplate = {
  templatePath: '/template/sheet/',
  width: '106px',
  height: '153px',
  items: [
    {
      thumnailImage: sheet_thumb02_attendancebook,
      thumnailImage2x: sheet_thumb02_attendancebook2x,
      titlei18nID: 'SheetTemplateItems.AttendanceBook',
      fileName: 'Attendance book.xlsx'
    },
    {
      thumnailImage: sheet_thumb03_babycarerecord,
      thumnailImage2x: sheet_thumb03_babycarerecord2x,
      titlei18nID: 'SheetTemplateItems.BabyCareRecord',
      fileName: 'Baby care record.xlsx'
    },
    {
      thumnailImage: sheet_thumb04_breakevenpoint,
      thumnailImage2x: sheet_thumb04_breakevenpoint2x,
      titlei18nID: 'SheetTemplateItems.Break-evenPoint',
      fileName: 'Break-even point.xlsx'
    },
    {
      thumnailImage: sheet_thumb05_budgetplanner1,
      thumnailImage2x: sheet_thumb05_budgetplanner12x,
      titlei18nID: 'SheetTemplateItems.BudgetPlanner1',
      fileName: 'Budget planner 1.xlsx'
    },
    {
      thumnailImage: sheet_thumb06_budgetplanner2,
      thumnailImage2x: sheet_thumb06_budgetplanner22x,
      titlei18nID: 'SheetTemplateItems.BudgetPlanner2',
      fileName: 'Budget planner 2.xlsx'
    },
    {
      thumnailImage: sheet_thumb07_chart,
      thumnailImage2x: sheet_thumb07_chart2x,
      titlei18nID: 'SheetTemplateItems.Chart',
      fileName: 'Chart.xlsx'
    },
    {
      thumnailImage: sheet_thumb09_estimate,
      thumnailImage2x: sheet_thumb09_estimate2x,
      titlei18nID: 'SheetTemplateItems.Estimate',
      fileName: 'Estimate.xlsx'
    },
    {
      thumnailImage: sheet_thumb10_health,
      thumnailImage2x: sheet_thumb10_health2x,
      titlei18nID: 'SheetTemplateItems.Health',
      fileName: 'Health.xlsx'
    },
    {
      thumnailImage: sheet_thumb11_invoice,
      thumnailImage2x: sheet_thumb11_invoice2x,
      titlei18nID: 'SheetTemplateItems.Invoice',
      fileName: 'Invoice.xlsx'
    },
    {
      thumnailImage: sheet_thumb12_loancalculator,
      thumnailImage2x: sheet_thumb12_loancalculator2x,
      titlei18nID: 'SheetTemplateItems.LoanCalculator',
      fileName: 'Loan Calculator.xlsx'
    },
    {
      thumnailImage: sheet_thumb13_meetingannouncement,
      thumnailImage2x: sheet_thumb13_meetingannouncement2x,
      titlei18nID: 'SheetTemplateItems.MeetingAnnouncement',
      fileName: 'Meeting announcement.xlsx'
    },
    {
      thumnailImage: sheet_thumb14_report,
      thumnailImage2x: sheet_thumb14_report2x,
      titlei18nID: 'SheetTemplateItems.Report',
      fileName: 'Report.xlsx'
    },
    {
      thumnailImage: sheet_thumb01_stock,
      thumnailImage2x: sheet_thumb01_stock2x,
      titlei18nID: 'SheetTemplateItems.Stock',
      fileName: 'Stock.xlsx'
    },
    {
      thumnailImage: sheet_thumb15_teamlist,
      thumnailImage2x: sheet_thumb15_teamlist2x,
      titlei18nID: 'SheetTemplateItems.TeamList',
      fileName: 'Team list.xlsx'
    },
    {
      thumnailImage: sheet_thumb16_trip,
      thumnailImage2x: sheet_thumb16_trip2x,
      titlei18nID: 'SheetTemplateItems.TripItinerary',
      fileName: 'Trip Itinerary.xlsx'
    }
  ]
};
